import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IdUploadComponent } from "./id-upload.component";
import { BrowserModule } from "@angular/platform-browser";
import { IdUploadModalModule } from './id-upload-modal.module';
import { WebcamModule } from 'ngx-webcam';
import { HeaderModule } from '../header/header.module';
import { SessionTimeoutModalModule } from '../session-timeout-modal/session-timeout-modal.module';
import { ProgressBarModule } from "../progress-bar/progress-bar.module";
import { ReactiveFormsModule } from "@angular/forms";
import { DragAndDropComponent } from "../drag-and-drop/drag-and-drop.component";
import { BackButtonConfirmationModalModule } from "../back-button-confirmation-modal/back-button-confirmation-modal.module";

@NgModule({
  declarations: [
    IdUploadComponent,
  ],
  providers: [
  ],
  imports: [
    BrowserModule,
    CommonModule,
    WebcamModule,
    IdUploadModalModule,
    HeaderModule,
    SessionTimeoutModalModule,
    ReactiveFormsModule,
    ProgressBarModule,
    DragAndDropComponent,
    BackButtonConfirmationModalModule
],
})
export class IdUploadModule {}
